import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
var CommonModalService = /** @class */ (function () {
    function CommonModalService(dialog) {
        this.dialog = dialog;
        // Default options for confirm modal
        this._confirmModalOptions = {
            height: '200px',
            width: '480px'
        };
    }
    Object.defineProperty(CommonModalService.prototype, "confirmModalOptions", {
        get: function () {
            return Object.assign({}, this._confirmModalOptions);
        },
        enumerable: true,
        configurable: true
    });
    CommonModalService.prototype.openModalWindow = function (modalComponent, options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            options = options || {};
            // {
            // 	width: options.width || '600px',
            // 	height: options.height || '50%',
            // 	data: options.data
            // }
            var dialogRef = _this.dialog.open(modalComponent, options);
            dialogRef.afterClosed()
                .catch(function (err) {
                reject(err);
                return Observable.throw(err);
            })
                .subscribe(function (rsp) { return resolve(rsp); });
        });
    };
    return CommonModalService;
}());
export { CommonModalService };
